module.exports = __webpack_public_path__ + "img/loan-success.ef202e47.png";